'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["cta"];
import { Record, Map as ImmutableMap } from 'immutable';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
const CURRENT_VERSION = 3;
export const PopupFormKeys = {
  NAME: 'name',
  ENABLED: 'enabled',
  SCHEDULED: 'scheduled',
  TYPE: 'type',
  SEND_NOTIFICATIONS: 'sendNotifications',
  ESP_SUBSCRIPTION_COUNT: 'espSubscriptionCount',
  COLOR: 'color',
  HEADING: 'heading',
  CTA: 'cta',
  COMPLETED_MESSAGE_HTML: 'completedMessageHtml',
  DESCRIPTION: 'description',
  DISPLAY_ON_MOBILE: 'displayOnMobile',
  DISPLAY_ON_SCROLL: 'displayOnMobile',
  DISPLAY_ON_EXIT_INTENT: 'displayOnExitIntent',
  DISPLAY_ON_TIME_DELAY: 'displayOnTimedDelay',
  SHOW_NAMES: 'showNames',
  SHOW_PHONE: 'showPhone',
  LEGAL_CONSENT_OPTIONS: 'legalConsentOptions',
  LOCALE: 'locale',
  DOUBLE_OPT_IN_ENABLED: 'doubleOptInEnabled',
  WHITELISTED_URLS: 'whitelistedUrls',
  PAGE_TYPES_LIST: 'pageTypesList',
  FORM_FIELDS: 'formFields',
  NOTIFICATION_EMAILS: 'notificationEmails',
  IGNORE_DURATION_DAYS: 'ignoreDurationDays',
  DISMISS_BUTTON_ENABLED: 'dismissButtonEnabled',
  IS_TYPE_EDITABLE: 'isTypeEditable',
  BUSINESS_UNIT_ID: 'businessUnitId'
};
export default class PopupForm extends Record({
  [PopupFormKeys.NAME]: '',
  [PopupFormKeys.ENABLED]: false,
  [PopupFormKeys.SCHEDULED]: false,
  [PopupFormKeys.TYPE]: 'POP_OVER',
  [PopupFormKeys.SEND_NOTIFICATIONS]: true,
  [PopupFormKeys.ESP_SUBSCRIPTION_COUNT]: 0,
  [PopupFormKeys.COLOR]: '#3288E6',
  [PopupFormKeys.HEADING]: '',
  [PopupFormKeys.CTA]: '',
  [PopupFormKeys.COMPLETED_MESSAGE_HTML]: '',
  [PopupFormKeys.DESCRIPTION]: '',
  [PopupFormKeys.DISPLAY_ON_MOBILE]: true,
  [PopupFormKeys.DISPLAY_ON_SCROLL]: false,
  [PopupFormKeys.DISPLAY_ON_EXIT_INTENT]: true,
  [PopupFormKeys.DISPLAY_ON_TIME_DELAY]: 0,
  [PopupFormKeys.SHOW_NAMES]: false,
  [PopupFormKeys.SHOW_PHONE]: false,
  [PopupFormKeys.LEGAL_CONSENT_OPTIONS]: {},
  [PopupFormKeys.LOCALE]: 'en',
  [PopupFormKeys.DOUBLE_OPT_IN_ENABLED]: true,
  [PopupFormKeys.WHITELISTED_URLS]: [],
  [PopupFormKeys.PAGE_TYPES_LIST]: [],
  [PopupFormKeys.FORM_FIELDS]: ImmutableMap({}),
  [PopupFormKeys.NOTIFICATION_EMAILS]: [],
  [PopupFormKeys.IGNORE_DURATION_DAYS]: 14,
  [PopupFormKeys.DISMISS_BUTTON_ENABLED]: false,
  [PopupFormKeys.IS_TYPE_EDITABLE]: false,
  [PopupFormKeys.BUSINESS_UNIT_ID]: 0
}) {
  constructor(defaultValues) {
    const internalDefaultValues = {
      [PopupFormKeys.HEADING]: I18n.text('defaultPopupForm.heading'),
      [PopupFormKeys.CTA]: I18n.text('defaultPopupForm.cta'),
      [PopupFormKeys.COMPLETED_MESSAGE_HTML]: `<p style="text-align: center">${I18n.text('defaultPopupForm.thanks')}</p>`,
      [PopupFormKeys.LOCALE]: getLang()
    };

    //hotfix: revert this and figure out real issue
    if (internalDefaultValues[PopupFormKeys.LOCALE] === 'pt') {
      internalDefaultValues[PopupFormKeys.LOCALE] = 'pt-br';
    }
    super(Object.assign({}, internalDefaultValues, defaultValues));
  }
  addFormField(name, label, type = 'string', formType = 'text', displayOrder = this.get(PopupFormKeys.FORM_FIELDS).size) {
    return this.set(PopupFormKeys.FORM_FIELDS, this.get(PopupFormKeys.FORM_FIELDS).set(name, {
      name,
      label,
      type,
      formType,
      displayOrder
    }));
  }
  getAsPreviewDefinition() {
    const _this$toJS = this.toJS(),
      {
        cta: ctaText
      } = _this$toJS,
      rest = _objectWithoutPropertiesLoose(_this$toJS, _excluded);
    return Object.assign({}, rest, {
      version: CURRENT_VERSION,
      ctaText
    });
  }
  toJS() {
    return Object.assign({}, super.toJS(), {
      [PopupFormKeys.FORM_FIELDS]: this.get(PopupFormKeys.FORM_FIELDS).toList().toJS()
    });
  }
  toJSON() {
    return Object.assign({}, super.toJSON(), {
      [PopupFormKeys.FORM_FIELDS]: this.get(PopupFormKeys.FORM_FIELDS).toList().toJSON()
    });
  }
}